import {
  FaGraduationCap,
  FaLaptopCode,
  FaPrint,
  FaUsers,
} from "react-icons/fa";

export default function TrustBand() {
  const items = [
    {
      icon: <FaGraduationCap />,
      title: "Formação prática",
      text: "Preparada para o mercado",
    },
    {
      icon: <FaLaptopCode />,
      title: "Tecnologia útil",
      text: "Soluções para o dia a dia",
    },
    {
      icon: <FaPrint />,
      title: "Produção cuidada",
      text: "Qualidade em cada detalhe",
    },
    {
      icon: <FaUsers />,
      title: "Apoio próximo",
      text: "Antes e depois da entrega",
    },
  ];

  return (
    <section className="trust-band">
      <div className="site-container trust-grid">
        {items.map((item) => (
          <div key={item.title}>
            {item.icon}
            <span>
              <strong>{item.title}</strong>
              <small>{item.text}</small>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
